<template>
  <div class="promo-card splashscreen">
    <div class="promo-card__card bg-white">
      <div class="promo-card__actions">
        <div>
          <!-- <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
            <a-select-option v-for="lang in langOptions" :key="lang.value">
              {{ lang.name }}
            </a-select-option>
          </a-select> -->
        </div>
        <div>
          <a-button type="link" :disabled="!editPermission" @click="openEditPage"><a-icon type="edit"
              class="text-primary font-size-16" />Edit</a-button>
        </div>
        <!-- <a-checkbox v-if="isViewscreen" :checked="addToViewscreen" :disabled="isCheckboxDisabled" @change="handleViewscreenChange"/> -->
      </div>
      <div class="promo-card__content" @click="openFullInfoModal">
        <div class="mb-3">
          <img class="promo-card__image" :src="splashscreenInfo.img_sm_path" alt="Splashscreen cover" />
        </div>
        <div class="promo-card__left">
          <div class="mb-2">
            <div class="promo-card--title">Tech name</div>
            <span class="promo-card-title promo-card--text">{{ splashscreenInfo.name }}</span>
          </div>
          <div>
            <div class="promo-card--title">Apps</div>
            <div style="line-height: 2.1rem">
              <a-tag style="margin-right: 15px; padding: 1px 8px; border-radius: 2px"
                v-for="app in splashscreenInfo.apps.slice(0, 2)" :key="app.id">
                {{ app.name }}
                <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
              </a-tag>
              <a-tag v-if="splashscreenInfo.apps.length > 2">
                ...
              </a-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="promo-card__footer">
        <div class="d-flex align-items-center">
          <div class="text-uppercase mr-auto">
            {{ formatDate(splashscreenInfo.starts_at) }} -
            <span>{{ formatDate(splashscreenInfo.ends_in) }}</span>
          </div>
          <div class="d-flex">
            <a-switch :default-checked="splashscreenInfo.is_active" @change="splashscreenActiveSwitch" :disabled="!editPermission" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import apiClient from '@/services/axios'
import MediaService from '@/services/api/apiMediaService'

export default {
  name: 'Splashscreen-card',
  props: {
    splashscreenInfo: {
      type: Object,
    },
    editPermission: {
      type: Boolean,
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    addToViewscreen: false,
  }),
  computed: {
    // langOptions() {
    //   const langKeys = Object.keys(this.splashscreenInfo.preview)
    //   return this.languages.filter(language => langKeys.includes(language.name)).map(language => ({
    //     name: language.desc,
    //     value: language.name,
    //   }))
    // },
    // selectedPreview() {
    //   return this.splashscreenInfo.preview[this.selectedLanguage]
    // },
  },
  watch: {
  },
  created() {
  },
  methods: {
    openFullInfoModal() {
      this.$emit('openFullInfo')
    },
    openEditPage() {
      this.$emit('openEdit')
    },
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
    // handleViewscreenChange(event) {
    //   this.addToViewscreen = event.target.checked
    //   const action = event.target.checked ? 'addToViewscreenArray' : 'deleteFromViewscreenArray'
    //   this.$emit(action, this.splashscreenInfo.id)
    // },
    async splashscreenActiveSwitch(checked) {
      try {
        const splashscreenPayload = {
          is_active: checked,
        }
        const splashscreensResponse = await MediaService.changeSplashscreenStatus(this.splashscreenInfo.id, splashscreenPayload)
        this.$notification.success({
          message: 'Active status changed',
          description: `${this.splashscreenInfo.name} status have been changed`,
        })
        if (splashscreensResponse.data.error) {
          const errorMessage =
          splashscreensResponse.data.error?.message ||
            'Something went wrong while updating story activity'
          this.$notification.error({
            message: errorMessage,
          })
          this.loading = false
          return
        }
      } catch (e) {
        const errorMessage =
          e.response.data?.error?.message ||
          'Something went wrong while updating story activity'
        this.$notification.error({
          message: errorMessage,
        })
      }
    },
  },
}
</script>

<style lang="scss" src="../style.module.scss" />
